import { faCaretUp, faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC } from 'react';
import styled, { css } from 'styled-components';
import { Colors } from 'src/styles';

type Props = {
  isOpen: boolean;
  showError?: boolean;
  disabled?: boolean;
  'data-testid'?: string;
};

export const SelectToggleIcon: FC<Props> = ({
  isOpen,
  showError,
  disabled,
  'data-testid': dataTestId,
}) => {
  return (
    <Wrapper error={showError} disabled={disabled} data-testid={dataTestId}>
      <FontAwesomeIcon icon={isOpen ? faCaretUp : faCaretDown} />
    </Wrapper>
  );
};

const Wrapper = styled.div<{
  error?: boolean;
  disabled?: boolean;
}>`
  color: ${Colors.brand};

  ${({ error }) =>
    error &&
    css`
      border-color: ${Colors.error};
      background-color: ${Colors.errorLighter};
      color: ${Colors.error};
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      border-color: ${Colors.inactive};
      background: ${Colors.inactiveLighter};
      cursor: not-allowed;
      color: ${Colors.inactive};
    `};
`;
